module.exports = __webpack_public_path__ + "img/one.be5030ca.webp";